import styled from "styled-components";
import { colGreen } from '../../../../constants/variables';

export const BlockTitle = styled.h2`
    font-family: 'OdinRounded', sans-serif;
    font-size: 60px;
    color: ${colGreen};
    line-height: 1;
    margin: 80px auto;
`;